
import { Component, Input } from '@angular/core';
import { Column } from '../../models/column.model';

@Component({
    selector: 'app-table-skeleton-loader',
    imports: [],
    templateUrl: './table-skeleton-loader.component.html',
    styleUrls: ['../table/table.component.scss', './table-skeleton-loader.component.scss']
})
export class TableSkeletonLoaderComponent {
  @Input() haveMultiActions: boolean = false;
  @Input() columns!: Column[];

  // For Skeletron
  getPlaceholderWidth(type: string): string {
    switch (type) {
      case 'string':
        return '8em';
      case 'email':
        return '12em';
      case 'number':
        return '3em';
      case 'date':
        return '6em';
      case 'counter':
        return '2em';
      case 'boolean':
        return '2em';
      case 'action':
        return '2em';
      default:
        return '0px'; // Default width
    }
  }
}
